import { useTranslation } from 'react-i18next';
import { useModal } from '../contexts';
import Modal from './Modal';

interface Props {
  onSave: () => void;
  onDontSave: () => void;
}

function WorkflowBlockModalSave(props: Props) {
  const { closeModal } = useModal();
  const { t } = useTranslation();

  function handleSave() {
    props.onSave();
    closeModal();
  }

  function handleDontSave() {
    props.onDontSave();
    closeModal();
  }

  return (
    <Modal
      title={t("Unsaved Changes")}
      subtitle={t("Would you like to save the changes you've made before exiting?")}
      secondaryButtonProps={{ onClick: handleDontSave, text: t("Don't Save") }}
      primaryButtonProps={{ onClick: handleSave, text: t("Save") }}
      size='sm'
    />
  );
}

export default WorkflowBlockModalSave;
